import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Autoridade from './components/Autoridade';
import Servicos from './components/Servicos';
import Diferencial from './components/Diferencial';
import Fechamento from './components/Fechamento';

const WA_NUMBER = '5511985111042';
const WA_MESSAGE = 'Olá! Gostaria de solicitar um orçamento exclusivo.';

export default function HomePage() {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => setShowTooltip(true), 3000);
    const hideTimer = setTimeout(() => setShowTooltip(false), 7000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-50 w-full overflow-x-hidden">
      <Hero isVisible={isVisible} />
      <Autoridade />
      <Servicos />
      <Diferencial />
      <Fechamento />

      {/* Botão flutuante WhatsApp */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
        {showTooltip && (
          <div className="bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-lg shadow-xl border border-gray-100 whitespace-nowrap animate-fade-in">
            💬 Fale conosco agora!
          </div>
        )}
        <button
          onClick={handleWhatsApp}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="w-14 h-14 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 cursor-pointer"
          aria-label="Falar pelo WhatsApp"
        >
          <i className="ri-whatsapp-line text-3xl"></i>
        </button>
      </div>
    </div>
  );
}
